import axios from './axios'
import * as model from '@/../../EshJSLib/models/patient';


export   async function hasPermission(permission:string) {
    
    let response = await   axios.post(`/api/security/hasPermission`, { data: permission }).then();
        
    return response.data.data as boolean;
}

